import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteBudgetAllocation = (id: number) => {
  return restApiClient.url(constructApiUrl(API.budgetAllocation.delete.url, { id })).delete()
}
